export default __webpack_public_path__ + "static/media/Scotsman@3x.ab92aa9b.png";